module.exports = __webpack_public_path__ + "static/media/edna08.22761b11.png";